package fr.manyverse.app.presentation.components.modules.timer

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.ActiveTimer
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.timer_active_timers
import org.jetbrains.compose.resources.stringResource

/**
 * Section displaying active timers for the GM in ModulesTab.
 * Shows countdown + targeted players count + pause/resume and stop buttons for each timer.
 */
@Composable
fun TimerGmSection(
    activeTimers: List<ActiveTimer>,
    onStopTimer: (String) -> Unit,
    onTogglePauseTimer: (String) -> Unit,
    onTimerExpired: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    if (activeTimers.isEmpty()) return

    Column(
        modifier = modifier.fillMaxWidth().padding(top = 16.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text(
            text = stringResource(Res.string.timer_active_timers),
            style = MaterialTheme.typography.titleSmall,
            color = MaterialTheme.colorScheme.primary
        )

        activeTimers.forEach { timer ->
            TimerGmCard(
                timer = timer,
                onStop = { onStopTimer(timer.id) },
                onTogglePause = { onTogglePauseTimer(timer.id) },
                onExpired = { onTimerExpired(timer.id) }
            )
        }
    }
}